// Country list (subset — Azerbaijan + neighbours + common foreign visitors).
// Add more codes here as needed; the selector in PhoneInput renders this list
// directly.
export const COUNTRIES = [
  { code: 'AZ', name: 'Azərbaycan', dial: '+994', flag: '🇦🇿' },
  { code: 'TR', name: 'Türkiyə', dial: '+90', flag: '🇹🇷' },
  { code: 'RU', name: 'Rusiya', dial: '+7', flag: '🇷🇺' },
  { code: 'US', name: 'ABŞ', dial: '+1', flag: '🇺🇸' },
  { code: 'GB', name: 'Böyük Britaniya', dial: '+44', flag: '🇬🇧' },
  { code: 'DE', name: 'Almaniya', dial: '+49', flag: '🇩🇪' },
  { code: 'FR', name: 'Fransa', dial: '+33', flag: '🇫🇷' },
  { code: 'IT', name: 'İtaliya', dial: '+39', flag: '🇮🇹' },
  { code: 'ES', name: 'İspaniya', dial: '+34', flag: '🇪🇸' },
  { code: 'NL', name: 'Hollandiya', dial: '+31', flag: '🇳🇱' },
  { code: 'CH', name: 'İsveçrə', dial: '+41', flag: '🇨🇭' },
  { code: 'AE', name: 'BƏƏ', dial: '+971', flag: '🇦🇪' },
  { code: 'SA', name: 'Səudiyyə Ərəbistanı', dial: '+966', flag: '🇸🇦' },
  { code: 'QA', name: 'Qətər', dial: '+974', flag: '🇶🇦' },
  { code: 'IR', name: 'İran', dial: '+98', flag: '🇮🇷' },
  { code: 'GE', name: 'Gürcüstan', dial: '+995', flag: '🇬🇪' },
  { code: 'AM', name: 'Ermənistan', dial: '+374', flag: '🇦🇲' },
  { code: 'KZ', name: 'Qazaxıstan', dial: '+7', flag: '🇰🇿' },
  { code: 'UZ', name: 'Özbəkistan', dial: '+998', flag: '🇺🇿' },
  { code: 'UA', name: 'Ukrayna', dial: '+380', flag: '🇺🇦' },
  { code: 'BY', name: 'Belarus', dial: '+375', flag: '🇧🇾' },
  { code: 'CN', name: 'Çin', dial: '+86', flag: '🇨🇳' },
  { code: 'JP', name: 'Yaponiya', dial: '+81', flag: '🇯🇵' },
  { code: 'KR', name: 'Cənubi Koreya', dial: '+82', flag: '🇰🇷' },
  { code: 'IN', name: 'Hindistan', dial: '+91', flag: '🇮🇳' },
  { code: 'IL', name: 'İsrail', dial: '+972', flag: '🇮🇱' },
  { code: 'EG', name: 'Misir', dial: '+20', flag: '🇪🇬' },
  { code: 'CA', name: 'Kanada', dial: '+1', flag: '🇨🇦' },
  { code: 'AU', name: 'Avstraliya', dial: '+61', flag: '🇦🇺' },
  { code: 'BR', name: 'Braziliya', dial: '+55', flag: '🇧🇷' },
  { code: 'PL', name: 'Polşa', dial: '+48', flag: '🇵🇱' },
  { code: 'RO', name: 'Rumıniya', dial: '+40', flag: '🇷🇴' },
];

export const DEFAULT_COUNTRY = 'AZ';
